import React, { useState } from 'react';
import '../../styles/landing/hero.css';
import { useNavigate } from 'react-router-dom';
import hero1920Webp from '../../assets/img/hero-1920.webp';
import hero2560Webp from '../../assets/img/hero-2560.webp';
import hero640Webp from '../../assets/img/hero-640.webp';

const HeroSection = () => {
	const navigate = useNavigate();
	const [loaded, setLoaded] = useState(false);

	const goToAbout = () => {
		navigate('/about');
		window.scrollTo(0, 0);
	};

	const goToProject = () => {
		navigate('/project');
		window.scrollTo(0, 0);
	};

  	return (
		<div className="landing-hero">
			<div id="landing-hero" className={`landing-hero-picture ${loaded ? 'is-loaded' : ''}`}>
				<svg className="wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2180 800">
					<defs>
						<clipPath id="waveClip1">
						<path d="M2180.5239,0H0v614.2603l10.729,3.3409c167.8439,52.2659,355.829,52.2659,523.673,0l10.729-3.3409,10.729-3.341c167.8439-52.2659,355.829-52.2659,523.673,0l10.729,3.341,10.729,3.3409c167.8439,52.2659,355.829,52.2659,523.6729,0l10.729-3.3409,20.7686-6.1936c169.1063-50.431,357.3806-48.2072,524.3621,6.1935h.0005s10.729,3.3411,10.729,3.3411c167.8438,52.2659,355.8289,52.2659,523.6729,0l10.729-3.3409,10.729-3.341c119.217-37.1237,248.5938-47.8694,373.6985-32.2563.7769-107.3251,1.7529-214.6487,2.6162-321.9731.9563-118.8946,1.761-237.7914,1.9963-356.6898h-934.1709Z">
							<animateTransform attributeName="transform" type="translate" from="0 -100" to="-1090 -100" dur="4s" repeatCount="indefinite"/>
						</path>
						<path data-name="line" d="M3110.758,580.901c-125.1047-15.6131-254.4814-4.8673-373.6985,32.2563l-10.729,3.341-10.729,3.3409c-167.844,52.2659-355.8291,52.2659-523.6729,0l-10.729-3.3409h-.0005c-166.9814-54.4008-355.2557-56.6246-524.3621-6.1936l-20.7686,6.1936-10.729,3.3409c-167.8439,52.2659-355.829,52.2659-523.6729,0l-10.729-3.3409-10.729-3.341c-167.844-52.2659-355.8291-52.2659-523.673,0l-10.729,3.341-10.729,3.3409c-167.8439,52.2659-355.829,52.2659-523.673,0l-10.729-3.3409v10l10.729,3.3409c167.8439,52.2659,355.829,52.2659,523.673,0l10.729-3.3409,10.729-3.341c167.8439-52.2659,355.829-52.2659,523.673,0l10.729,3.341,10.729,3.3409c167.8439,52.2659,355.829,52.2659,523.6729,0l10.729-3.3409,20.7686-6.1936c169.1063-50.431,357.3806-48.2072,524.3621,6.1935h.0005s10.729,3.3411,10.729,3.3411c167.8438,52.2659,355.8289,52.2659,523.6729,0l10.729-3.3409,10.729-3.341c119.217-37.1237,248.5938-47.8694,373.6985-32.2563">
							<animateTransform attributeName="transform" type="translate" from="0 -100" to="-1090 -100" dur="4s" repeatCount="indefinite"/>
						</path>
						</clipPath>
					</defs>
				</svg>

				{/* Sharp image: fade in only */}
				<img
					src={hero640Webp}
					srcSet={`${hero1920Webp} 1920w, ${hero2560Webp} 2560w`}
					sizes="100vw"
					alt=""
					loading="eager"
					fetchpriority="high"
					decoding="async"
					className="hero-img"
					onLoad={() => setLoaded(true)}
				/>

				<div className="landing-hero-overlay"></div>
			</div>

			<div className="landing-hero-info">
				Integrating Proteomics into Precision Medicine for Improved Patient Outcomes
			</div>

			<div className="landing-hero-cta">
				<h2> Project Structure</h2>
				<p> Learn more about ProMS or the project infrastructure by the links below: </p>
				<span className="landing-hero-cta-buttons">
				<button onClick={goToAbout}>View about page</button>
				<button onClick={goToProject}>View project structure</button>
				</span>
			</div>
		</div>
	);
};

export default HeroSection;
